
import * as strapiRuntime$esc0L12crY from '/home/runner/work/vaneerd-werkenbij/vaneerd-werkenbij/website/node_modules/@nuxt/image/dist/runtime/providers/strapi'
import * as ipxRuntime$t2QNmt3pZf from '/home/runner/work/vaneerd-werkenbij/vaneerd-werkenbij/website/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['strapi']: { provider: strapiRuntime$esc0L12crY, defaults: {"baseURL":"https://strapi.werkenbijvaneerd.nl/uploads/"} },
  ['ipx']: { provider: ipxRuntime$t2QNmt3pZf, defaults: {} }
}
        